import React from "react";
import { OptimizelyLinkCollection, OptimizelyLongString } from "../../types/optimizely/blocks";

interface LinkListBlockProps {
    title: OptimizelyLongString;
    links: OptimizelyLinkCollection;
}

const LinkListBlock = (props: LinkListBlockProps) => {
    const { title, links } = props;

    return (
        <div>
            <p>{title.value}</p>
            {links.value.map(link => (
                <p><a className="text-[16px] font-bold text-primary underline" href={link.href}>{link.text}</a></p>
            ))}
        </div>
    );
}

export default LinkListBlock;